
<!--
 * @Author: mzw
 * @Date: 2025-04-24 14:50:19
 * @LastEditTime: 2025-04-24 14:50:19
 * @LastEditors: mzw
 * @Description: 
-->
<template>
  <div class="chat-line chat-line-prompt">
    <div class="chat-line-inner">
      <div class="chat-item">
        <!-- 内容 -->
        <div class="content" v-html="itemObj.content"></div>
        <div class="rf ac jsb">
        <!-- 操作按钮 -->
        <div class="bar" v-if="isReviewFile">
          <!-- 预览 -->
          <span
            class="bar-icon-item"
            v-if="isReviewFile"
            @click="reviewFile"
          >
            <el-tooltip
              class="box-item"
              effect="dark"
              content="预览"
              placement="top"
            >
              <i class="el-icon-view"></i>
            </el-tooltip>
          </span>
        </div>
        <!-- 时间 -->
        <span class="time">{{itemObj.questionTime}}</span>
        </div>
      </div>
      <div class="chat-icon">
        <img src="~@/assets/img/AI/default_avatar.png" alt="User" />
      </div>
    </div>

    <!-- 图片预览 -->
    <!-- <teleport to="body">
      <div v-if="preImgVisible" class="modal-overlay rf ac jc" @click="preImgVisible = false">
        <div class="modal-image">
          <img :src="itemObj.fileAliOssObj.url" alt="Image preview" />
        </div>
      </div>
    </teleport> -->
  </div>
</template>

<script>
export default {
  name: 'ChatPrompt',
  props: {
    itemObj: {
      type: Object
    }
  },
  data() {
    return {
      // preImgVisible: false
    }
  },
  computed: {
    //是否有文件预览按钮
    isReviewFile(){
      if(this.itemObj.fileAliOssObj){
        return true
      } else {
        return false
      }
    }
  },
  mounted() {},
  methods: {
    reviewFile(){
      if(['fileClassify','fileGoodsMatch'].includes(this.itemObj.questionType)){ //excle预览
        // 部分文件不支持?↓
        window.open('https://view.officeapps.live.com/op/view.aspx?src='+encodeURIComponent(this.itemObj.fileAliOssObj.url))
        // 收费↓
        // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(this.itemObj.fileAliOssObj.url))
      } else {
        if(this.itemObj.fileAliOssObj){ //文件
          if( this.itemObj.fileAliOssObj.fileType==='pdf'){ //pdf预览
            // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(this.itemObj.fileAliOssObj.url))
            window.open(this.itemObj.fileAliOssObj.url)
          } else { //图片预览
            // this.preImgVisible = true
            this.imgShow()
          }
        }
      }
    },
    imgShow() {
      const image = new Image()
      image.src = this.itemObj.fileAliOssObj.url
      image.onload = () => {
        //创建弹出层
        const previewContatiner = document.createElement('div')
        previewContatiner.style.position = 'fixed'
        previewContatiner.style.top = 0
        previewContatiner.style.bottom = 0
        previewContatiner.style.left = 0
        previewContatiner.style.right = 0
        previewContatiner.style.zIndex = 9999
        previewContatiner.style.backgroundColor = 'rgba(0,0,0,0.8)'
        previewContatiner.style.display = 'flex'
        previewContatiner.style.justifyContent = 'center'
        previewContatiner.style.alignItems = 'center'
        document.body.appendChild(previewContatiner)
        //在弹出层增加图片
        const previewImage = document.createElement('img')
        previewImage.src = this.itemObj.fileAliOssObj.url
        previewImage.style.maxWidth = '96%'
        previewImage.style.maxHeight = '96%'
        previewImage.style.zIndex = 9999
        previewContatiner.appendChild(previewImage)
        //点击弹出层，关闭预览
        previewContatiner.addEventListener('click', () => {
          document.body.removeChild(previewContatiner)
        })
      }
      image.onerror = function () {
        console.log('图片加载失败')
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/chat/chat-prompt.scss";
</style>